import { Injectable } from '@angular/core';
import { NgForage } from 'ngforage';
import { Subject } from 'rxjs';
import * as semaphore from 'semaphore';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import SemaphoreHelper from 'src/app/helpers/semaphore-helper';

@Injectable({
  providedIn: 'root'
})
export class ImmoIPPlacerSubmitInProgressService {
  private readonly storageKey = 'immo-ip-submit-in-progress';
  private readonly submitInProgressSemaphore = semaphore(1);
  private readonly submitInProgressChanged = new Subject<any>();

  constructor(private ngForage: NgForage) {}

  public async getSubmitInProgress(): Promise<ImmoIPSubmitInProgressEntry[]> {
    let toReturn: ImmoIPSubmitInProgressEntry[] = null;
    await SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      toReturn = await this.ngForage.getItem(this.storageKey);
    });
    return toReturn;
  }

  public async isInProgress(subProjectId: number): Promise<boolean> {
    let toReturn = null;
    await SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      const inProgress: ImmoIPSubmitInProgressEntry[] = await this.ngForage.getItem(
        this.storageKey
      );
      toReturn =
        CollectionHelper.isPopulated(inProgress) &&
        inProgress.some(p => p.subProjectId === subProjectId);
    });
    return toReturn;
  }

  public setSubmitInProgress(subProjectId: number): Promise<void> {
    return SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      let inProgress: ImmoIPSubmitInProgressEntry[] = await this.ngForage.getItem(
        this.storageKey
      );
      inProgress = inProgress != null ? inProgress : [];
      inProgress.push({ subProjectId: subProjectId });
      await this.ngForage.setItem(this.storageKey, inProgress);
      this.submitInProgressChanged.next();
    });
  }

  public removeSubmitInProgress(subProjectId: number): Promise<void> {
    return SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      const inProgress: ImmoIPSubmitInProgressEntry[] = await this.ngForage.getItem(
        this.storageKey
      );
      if (inProgress != null) {
        CollectionHelper.filterInPlace(
          inProgress,
          p => p.subProjectId !== subProjectId
        );
        await this.ngForage.setItem(this.storageKey, inProgress);
      }
      this.submitInProgressChanged.next();
    });
  }

  public getSubmitInProgressChangedSubscribable(): Subject<any> {
    return this.submitInProgressChanged;
  }
}

export interface ImmoIPSubmitInProgressEntry {
  subProjectId: number;
}
